// import { registrationSaveContact } from 'constants/routes';

// TODO: for some reason the above import is not working.
// hardcoding the URL for now.
const baseElementUrl = document.querySelector('base').attributes.href.value;
const registrationSaveContact = `${baseElementUrl}/learn/dynamic/SaveRegistrationContact`;

export default function postRegistrationData(data) {
  const payload = {
    Email: data.email,
    PhoneNumber: data.phone,
    FirstName: data.firstName,
    LastName: data.lastName
  };

  return fetch(registrationSaveContact, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(responseJson => {
      if (responseJson.success) {
        return responseJson;
      }
      throw new Error(responseJson.message);
    });
}
